import { sendSignInLinkToEmail } from "firebase/auth"
import { auth } from "./init"

/**
 * Sends a sign-in link to the user's email address. The link will be valid for
 * about 6 hours.
 *
 * @see https://firebase.google.com/docs/auth/web/email-link-auth
 */
export async function sendSignInLink(email: string): Promise<void> {
  const actionCodeSettings = {
    handleCodeInApp: true,
    // The domain for this URL must be in the authorized domains list in the
    // Firebase Console.
    url: `${window.location.protocol}//${window.location.host}/account`,
  }
  await sendSignInLinkToEmail(auth, email, actionCodeSettings)
  // The link was successfully sent. Inform the user.
  // Save the email locally so you don't need to ask the user for it again
  // if they open the link on the same device.
  window.localStorage.setItem("frontender-auth-email", email)
}
